import { FC, ReactElement } from 'react'

import { ImageIcon } from '@phosphor-icons/react'
import * as AvatarPrimitive from '@radix-ui/react-avatar'

import { avatarVariants } from '../styles'
import { AvatarContentProps } from '../types'

export const AvatarContent: FC<AvatarContentProps> = (props): ReactElement => {
  const { altImg, classNameImg, icon: Icon = ImageIcon, iconSize, mode, size, url } = props

  const { image } = avatarVariants({ mode, size })

  const getIconSize = (): number => {
    switch (size) {
      case '3xs':
        return iconSize ?? 12
      case 'xxs':
        return iconSize ?? 16
      case 'xs':
        return iconSize ?? 24
      case 'sm':
        return iconSize ?? 34
      case 'md':
        return iconSize ?? 54
      case 'lg':
        return iconSize ?? 74
      case 'xl':
      case 'full':
        return iconSize ?? 94
      default:
        return 74
    }
  }

  return (
    <>
      <AvatarPrimitive.Image
        src={url ?? ''}
        alt={altImg ?? 'avatar-image'}
        className={image({ className: classNameImg })}
      />

      <AvatarPrimitive.Fallback delayMs={600}>
        <Icon size={getIconSize()} className="text-accent-1 dark:text-accent-2" weight="bold" />
      </AvatarPrimitive.Fallback>
    </>
  )
}

AvatarContent.displayName = 'Avatar.Content'
